import { createContext } from 'react'

export const AuthContext = createContext({
  token: null,
  hasAccess: false,
  accessIssue: null,
  authInitialized: false,
  setToken: () => {},
  markHasAccess: () => {},
  markNoAccess: () => {},
  setAccessIssue: () => {},
  redirectToLogin: () => {},
  relogin: () => {},
  decodeToken: () => null,
  hasActivationPermission: () => null,
})
